import {createAction} from 'web-app/util/redux/famly-app-helpers';

import {type FormData} from './models';

const domain = 'EDIT_TAG';

export const {
    action: fetch,
    success: fetchSuccess,
    failed: fetchFailed,
} = createAction(
    `${domain}/FETCH_TAG`,
    (institutionId: string) => ({institutionId}),
    () => ({}),
);

export const {
    action: update,
    success: updateSuccess,
    failed: updateFailed,
} = createAction(
    `${domain}/UPDATE_TAG`,
    (institutionId: string, tagId: string, formData: FormData) => ({institutionId, tagId, formData}),
    () => ({}),
);

export const {
    action: deleteTag,
    success: deleteTagSuccess,
    failed: deleteTagFailed,
} = createAction(
    `${domain}/DELETE_TAG`,
    (tagId: string) => ({tagId}),
    () => ({}),
);
